import * as d3 from 'd3-selection'

export default function (id, cornerRadius, width, height, x, y) {
  return function (selection) {
    selection.each(function (data) {
      var defs = d3.select(this)
                   .selectAll('defs')
                   .data(function (d) {
                     return [d]
                   })
        , enter = defs.enter()
                      .insert('defs', ':first-child')
        , shadowWidth = '200%'
        , shadowHeight = '130%'
        , shadowXOffset = '-50%' // (100% - shadowWidth) / 2
        , shadowYOffset = '-15%' // (100% - shadowHeight) / 2
        , isVertical = width < height

      enter.append('rect')
           .attr('id', 'border-shape-' + id)
           .merge(defs.select('rect'))
           .attr('rx', cornerRadius)
           .attr('ry', cornerRadius)
           .attr('width', width)
           .attr('height', height)
           .attr('x', x)
           .attr('y', y)

      var filter = enter.append('filter')
                        .attr('id', 'shadow-' + id)
                        .attr('x', isVertical ? shadowXOffset : shadowYOffset)
                        .attr('y', isVertical ? shadowYOffset : shadowXOffset)
                        .attr('width', isVertical ? shadowWidth : shadowHeight)
                        .attr('height', isVertical ? shadowHeight : shadowWidth)

      filter.append('feOffset')
            .attr('dx', '0')
            .attr('dy', '2')
            .attr('in', 'SourceAlpha')
            .attr('result', 'offOut')

      filter.append('feGaussianBlur')
            .attr('result', 'blurOut')
            .attr('stdDeviation', '1.5')
            .attr('in', 'offOut')

      var mask = enter.append('mask')
                      .attr('id', 'mask-' + id)
                      .attr('x', isVertical ? shadowXOffset : shadowYOffset)
                      .attr('y', isVertical ? shadowYOffset : shadowXOffset)
                      .attr('width', isVertical ? shadowWidth : shadowHeight)
                      .attr('height', isVertical ? shadowHeight : shadowWidth)

      process.nextTick(function () {
        // The mask needs a background that is completely white. This creates
        // a white background shape that extends beyond the original size to allow
        // everything to show through it.
        // Append the rect and use tags on nextTick. There's a bug in
        // webkit where the mask isn't rendered correctly at first
        mask.append('rect')
            .attr('id', 'mask-background-' + id)
            .merge(defs.select('mask rect'))
            .attr('x', '-10%')
            .attr('y', '-10%')
            .attr('width', '120%')
            .attr('height', '120%')
            .attr('fill', 'white')

        // This draws a black shape that we're using to cut the content out.
        mask.append('use')
          .attr('xlink:href', '#border-shape-' + id)
          .attr('fill', 'black')
      })

    })
  }
}
